module.exports = __webpack_public_path__ + "img/element_1.ea00b191.png";